module.exports = __webpack_public_path__ + "static/media/close.965abec4.svg";